<script>
import qs from 'qs'
import { Popup, Icon } from 'bxs-ui-vue'
import { PBF_UAT_HOSTNAME } from 'common/utils/variables'
import { isBxs } from 'base/config'
import { haveRecommend, queryAdvert, pbCompare } from 'api/index'
import { getLocalStorage, setLocalStorage } from 'common/js/common'
const POSITION_NUM_RF = 4 // 回流弹窗
const POSITION_NUM_COMPARE = 16 // 是否有对比
const LS_REFLOW = 'WeiyiStat_pbr_reflow'
const NG_TIME = 1000 * 60 * 60 * 24 * 7 // 7天

export default {
  name: 'ReflowBox',
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon,
  },
  props: {
    uuid: String,
    insuranceTypeId: Number,
    insuredInfo: Object,
    isPreInvitation: Boolean,
  },
  data() {
    return {
      isShow: false,
      reflow: {
        description: '',
        extendData: '',
        id: null,
        image: '',
        link: '',
        name: '',
        type: null,
      },
      aspectRatio: null,
    }
  },
  computed: {
    extendData() {
      const { reflow } = this
      if (!reflow.extendData) return {}
      return JSON.parse(reflow.extendData)
    },
  },
  watch: {
    isShow(value) {
      try {
        // 曝光 hltc
        // 关闭 hltc_cel
        window.WeiyiStatSDK.submit(value ? 'hltc' : 'hltc_cel', {
          bannerId: this.reflow.id,
        })
      } catch (err) {
        console.warn('[WeiyiStatSDK]hltc', err)
      }
    },
  },
  created() {
    this.firstView = true
    // |not supported ios|
    if (window.appBridge && appBridge.checkAppFeature('SHARING_AWARE')) {
      appBridge.onSharingDone((sharingResult) => {
        // 分享未成功回调 or 同屏分享不显示
        // 区分同屏分享：isPreInvitation == true
        if (!sharingResult.success || this.isPreInvitation) return
        this.subSequent()
      })
    }
  },
  methods: {
    async subSequent() {
      const { uuid, insuranceTypeId, insuredInfo } = this
      let toCompare = null
      let toRecommend = false
      // 对比
      const compareParams = {
        position: POSITION_NUM_COMPARE,
        relationId: insuranceTypeId,
      }
      // 推荐
      const recParams = {
        pbId: insuranceTypeId,
        sex: insuredInfo.sex,
        age: insuredInfo.age,
      }
      // 回流
      const params = {
        position: POSITION_NUM_RF,
        relationId: insuranceTypeId,
      }
      try {
        if (isBxs) {
          await queryAdvert(qs.stringify(compareParams)).then(
            ({ data, success } = {}) => {
              const { recommendProduct } = data[0] || {}
              if (!success || !recommendProduct) return
              // 预留多款，当前取第一个
              toCompare = recommendProduct[0]
              toCompare && (this.reflow = data[0])
            }
          )
          if (toCompare) {
            await pbCompare({
              resultUuid: uuid,
              compareProductId: toCompare,
            }).then(({ success, data } = {}) => {
              if (!success && !data) return
              this.reflow.link = `${PBF_UAT_HOSTNAME}/planBook/planBookResult/pages/planbkContrastCollection.html?nw=1&uuid=${data}`
              this.isShow = this.checkAdvertDisplay()
            })
            return
          }
          // 保险师-显示回流推荐
          await haveRecommend(recParams).then(({ success, data } = {}) => {
            if (success && data) toRecommend = true
          })
        }
        if (toRecommend) {
          location.href = `${PLANBOOK_PAGE_MAP.productsRecommended}?nw=1&pbId=${insuranceTypeId}&sex=${insuredInfo.sex}&age=${insuredInfo.age}`
        } else {
          await queryAdvert(qs.stringify(params)).then(
            ({ data, success } = {}) => {
              const { image, description } = data[0] || {}
              if (!success || !image || !description) return
              this.reflow = data[0]
              this.isShow = this.checkAdvertDisplay()
            }
          )
        }
      } catch (error) {
        console.log('async error', error)
      }
    },
    handleBeforeClose(action, done) {
      const { reflow } = this
      const isConfirm = action === 'confirm'
      const btnId = isConfirm ? 'hltc_def' : 'hltc_cel'
      window.WeiyiStatSDK.submit(btnId, {
        bannerId: reflow.id,
      })
      if (isConfirm) {
        location.href = reflow.link
      } else {
        done()
      }
    },
    checkAdvertDisplay() {
      const { insuranceTypeId, reflow, firstView } = this
      if (!firstView) return false
      let lastReflow = getLocalStorage(LS_REFLOW)
      // fix
      if (!lastReflow || !isNaN(lastReflow)) {
        lastReflow = {}
      }
      if (lastReflow[insuranceTypeId] == reflow.id) return false
      this.firstView = false
      lastReflow[insuranceTypeId] = reflow.id
      setLocalStorage(LS_REFLOW, lastReflow, NG_TIME)
      return true
    },
    imgLoad(e) {
      const imgElm = e.target
      this.aspectRatio = (imgElm.height / imgElm.width) * 100 + '%'
    },
  },
}
</script>
<template>
  <bxs-message-box
    v-model="isShow"
    :confirm-button-text="extendData.confirmTx || '点击查看'"
    :cancel-button-text="extendData.cancelTx || '残忍拒绝'"
    @before-close="handleBeforeClose"
  >
    <div class="reflow-content">
      <div class="hd">
        <a :href="reflow.link" class="reflow-link">
          <img class="reflow-img" alt="回流弹窗" :src="reflow.image">
        </a>
      </div>
      <div class="bd">
        <a class="reflow-text" :href="reflow.link">{{ reflow.description }}</a>
      </div>
    </div>
  </bxs-message-box>
  <!-- <bxs-popup class="native-popup" v-model="isShow" :lock-scroll="true">
    <a
      class="native-dialog"
      data-stat-id="hltc_def"
      :data-stat-ep="JSON.stringify({ bannerId: reflow.id })"
      :href="reflow.link"
      :style="{ 'padding-bottom': aspectRatio }"
    >
      <img :alt="reflow.description" :src="reflow.image" @load="imgLoad" />
    </a>
    <bxs-icon name="close-plain" @click.native="isShow = false"></bxs-icon>
  </bxs-popup> -->
</template>
<style lang="postcss" scoped>
.native-popup {
  font-size: 0;
  text-align: center;
  background-color: transparent;
  .native-dialog {
    overflow: hidden;
    display: block;
    width: 5.4rem;
    /* height: 8rem; */
    /* padding: 0 0.3rem; */
    margin-bottom: 0.42rem;
    background-color: #fff;
    font-size: 0.28rem;
    border-radius: 0.12rem;
    > img {
      z-index: 1;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      border-radius: 0.12rem;
    }
  }
  .bx-icon-close-plain {
    color: #fff;
    font-size: 0.6rem;
  }
}
</style>
